<template>
  <span v-show="isShowPage">
    <v-row align="center" justify="center">
      <v-col cols="3">
        <v-text-field
          append-icon="mdi-magnify"
          outlined
          solo
          hide-details
          v-model="search"
          class="search"
          placeholder="Search..."
          v-on:keyup.enter="getDataTable()"
          color="#2671D9"
        >
        </v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <v-col class="text-right">
        <v-btn
          class="ma-2"
          depressed
          outlined
          color="#2671D9"
          @click="exportExcel()"
        >
          <v-icon left color="#2671D9"> $ic-export-excel </v-icon>
          Export Excel
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0">
        <Table
          :headers="headers"
          :items="items"
          @onChangePage="getDataTable"
          @sortOptions="updateSortDatatable"
          :defaultSize="5"
          :loading="isFetching"
        >
          <template slot="unit" slot-scope="{ item }">
            {{ capitalize(item.unit) }}
          </template>
          <template slot="charger" slot-scope="{ item }">
            {{ capitalize(item.charger) }}
          </template>
          <template slot="statusDateSecondAgo" slot-scope="{ item }">
            {{ secondToHoursAndMinutes(item.statusDateSecondAgo) }}
          </template>
        </Table>
      </v-col>
    </v-row>
  </span>
</template>
<script>
import Table from "../../components/Table.vue";
import MonitoringService from "@/services/default/MonitoringService";
import alert from "@/commons/helper/alert.helper";
import { StorageService } from "@/services/storage.service";

const monitoringService = MonitoringService.build();
export default {
  name: "monitoring-spklu-dc-v2",
  components: {
    Table,
  },
  data: () => ({
    colorActive: "#2671D9",
    colorInactive: "#9A9A9A",
    headers: [
      {
        value: "number",
        text: "No.",
        sortable: false,
        align: "center",
        width: "50px",
      },
      { value: "unit", text: "Unit", align: "left", width: "170px" },
      {
        value: "spkluName",
        text: "Lokasi SPKLU",
        align: "left",
        width: "180px",
      },
      { value: "merek", text: "Merek", align: "left", width: "120px" },
      { value: "charger", text: "Charger", align: "left", width: "120px" },
      { value: "kapasitas", text: "Kapasitas", align: "left", width: "120px" },
      { value: "statusName", text: "Status", align: "left", width: "120px" },
      {
        value: "statusDateSecondAgo",
        text: "Waktu Status",
        align: "center",
        width: "150px",
      },
    ],
    items: {},
    search: "",
    sortSettings: "",
    isShowPage: true,
    isFetching: false,
    timer: "",
  }),
  async created() {
    // delete localStorage
    localStorage.removeItem("tableQuery");
  },
  computed: {},
  mounted: async function () {
    const responseAuth = await StorageService.getAuthdata();
    const branchName = responseAuth.branch.name.toLowerCase();

    let tableQuery = JSON.parse(localStorage.getItem("tableQuery"));
    localStorage.setItem(
      "tableQuery",
      JSON.stringify({
        page: tableQuery ? tableQuery.page : 0,
        size: tableQuery ? tableQuery.size : 20,
        sort_by: this.sortSettings,
      })
    );
    tableQuery = JSON.parse(localStorage.getItem("tableQuery"));
    await this.getDataTable(tableQuery.page, tableQuery.size);

    if (branchName === "pusat") {
      this.search = "";
      await this.updateSortDatatable(tableQuery.sort_by);
      await this.getDataTable(tableQuery.page, tableQuery.size);
    } else {
      this.search = branchName;
      await this.updateSortDatatable(tableQuery.sort_by);
      await this.getDataTable(tableQuery.page, tableQuery.size);
    }

    this.$nextTick(() => {
      // re-get data every 1 minute
      this.timer = setInterval(() => {
        const tableQuery = JSON.parse(localStorage.getItem("tableQuery"));
        if (tableQuery) {
          this.getDataTable(tableQuery.page, tableQuery.size);
        } else {
          this.getDataTable();
        }
      }, 60000);
    });
  },
  destroyed: function () {
    // kill re-get data every 1 minute
    clearInterval(this.timer);
  },
  watch: {
    search: function (val) {
      if (val === "") {
        this.getDataTable();
      }
    },
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    async resetData() {
      this.items = {};
      // this.search = ''
      this.sortSettings = "";
    },
    async getDataTable(page, size) {
      this.isFetching = true;
      this.paging.page = page;
      this.paging.size = size;

      let tableQuery = JSON.parse(localStorage.getItem("tableQuery"));

      localStorage.setItem(
        "tableQuery",
        JSON.stringify({
          page: page,
          size: size,
          sort_by: tableQuery ? tableQuery.sort_by : "",
        })
      );

      // re-get data after set
      tableQuery = JSON.parse(localStorage.getItem("tableQuery"));

      const param = Object.assign(
        {
          q: this.search,
          sort: tableQuery ? tableQuery.sort_by : "",
        },
        this.paging
      );

      const response = await monitoringService.getPgbUnavailableSpkluDc(param);
      // console.log("response  >>>", response.data.data.content);
      if (response.data.success === true) {
        const {
          data: {
            data: { content, totalPages, number, size, totalElements },
          },
        } = response;
        this.items = Object.assign({
          data: content,
          total: totalPages,
          size,
          page: number + 1,
          totalElements,
        });
      } else {
        alert.failed(response.data.status + " - " + response.data.message);
      }
      this.isFetching = false;
    },
    async updateSortDatatable(options) {
      if (options.sortBy) {
        this.sortSettings = "";
        for (let i = 0; i < options.sortBy.length; i++) {
          const sort = options.sortDesc[i] === false ? "asc" : "desc";
          let column = "";

          if (options.sortBy[i] === "unit") {
            column = "unit";
          } else if (options.sortBy[i] === "spkluName") {
            column = "spkluName";
          } else if (options.sortBy[i] === "merek") {
            column = "merek";
          } else if (options.sortBy[i] === "charger") {
            column = "charger";
          } else if (options.sortBy[i] === "kapasitas") {
            column = "kapasitas";
          } else if (options.sortBy[i] === "statusName") {
            column = "statusName";
          } else if (options.sortBy[i] === "statusDateSecondAgo") {
            column = "statusDateSecondAgo";
          }

          if (i === 0) {
            this.sortSettings += column + "," + sort;
          } else {
            this.sortSettings += "&sort=" + column + "," + sort;
          }
        }

        let tableQuery = JSON.parse(localStorage.getItem("tableQuery"));
        localStorage.setItem(
          "tableQuery",
          JSON.stringify({
            page: tableQuery ? tableQuery.page : 0,
            size: tableQuery ? tableQuery.size : 20,
            sort_by: this.sortSettings,
          })
        );
        tableQuery = JSON.parse(localStorage.getItem("tableQuery"));
        this.getDataTable(tableQuery.page, tableQuery.size);
      }
    },
    async exportExcel() {
      const param = {
        name: "Data Unavailable " + new Date() + ".xlsx",
      };
      await monitoringService.exportUnavailableSpkluDC(param);
    },
  },
};
</script>
<style scoped>
.search {
  height: 48px;
}
</style>
